import './index.scss';

import { VolunteerTeamRole } from '@data/interfaces/Volunteering/volunteerteam.interface';

/// Adds a role that isn't held and removes one that is. Meant for a functional
/// state update, so toggles made before a re-render still compose rather than
/// each overwriting the last.
export function toggleRoleID(roleIDs: string[], roleID: string) {
  return roleIDs.includes(roleID) ?
    roleIDs.filter((heldRoleID) => heldRoleID !== roleID) :
    [...roleIDs, roleID];
}

// A team's roles as toggleable pills. A volunteer can hold several at once, or
// none at all.
export default function RolePicker(props: {
  roles: VolunteerTeamRole[];
  selectedRoleIDs: string[];
  disabled?: boolean;
  onToggle: (roleID: string) => void;
}) {
  const selected = new Set(props.selectedRoleIDs);
  const sortedRoles = [...props.roles].sort((one, two) => one.attributes.name.localeCompare(two.attributes.name));

  return <div className='role-picker' role='group' aria-label='Roles'>
    {sortedRoles.map((role) => {
      const isSelected = selected.has(role.id);

      return <button
        key={role.id}
        type='button'
        className={isSelected ? 'role-chip is-selected' : 'role-chip'}
        aria-pressed={isSelected}
        disabled={props.disabled}
        onClick={() => props.onToggle(role.id)}>
        {role.attributes.name}
      </button>
    })}
  </div>
}
